import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../config/authConfig";

const LoginPage = () => {
  const { instance } = useMsal();

  useEffect(() => {
    console.log(process.env.REDIRECT_URI);
    async function msalLogin() {
      await instance.loginRedirect(loginRequest());
    }
    msalLogin();
  }, []);

  return <></>;
};

export default LoginPage;
